exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wz_loadingChat{\n  top: calc(50% - 35px);\n  position: relative;\n}\n.list__tile {\n  -webkit-user-select: auto !important;\n      -ms-user-select: auto !important;\n          user-select: auto !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheebox/WzFicheInfosVisiteur.vue
// module id = IKLF
// module chunks = 1